import { render, staticRenderFns } from "./CurrentLocationControl.vue?vue&type=template&id=245e4992&"
import script from "./CurrentLocationControl.vue?vue&type=script&lang=js&"
export * from "./CurrentLocationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports